import { render } from "./page-sell.vue?vue&type=template&id=23b07e95"
import script from "./page-sell.js?vue&type=script&lang=js"
export * from "./page-sell.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__